// Dev server environment (--configuration=dev) — this is the build DEV2 runs.
//
// TWO backends, on TWO hosts. Getting these mixed up is what took the site down:
//
//   dev2.mahattaart.com   Angular website + the OLD Laravel backend
//                         mounted so its routes answer at /api/api/…
//                         (verified: /api/api/unauth/category → 200,
//                                    /api/api/auth/cart      → 401)
//
//   dev3.mahattaart.com   React panel + the NEW Laravel backend,
//                         mounted under /adminapi
//                         (verified: /adminapi/api/site/…    → 200,
//                                    /adminapi/api/lookups   → 401,
//                          and WITHOUT the prefix → 500 with an empty body)
//
// The previous values pointed the OLD backend at dev3 (every legacy call 404'd)
// and dropped the /adminapi prefix from the new one (every /api/site call died).
// A 404 or 500 carries no CORS headers, so the browser reported all of it as a
// CORS error — which is why changing CORS config did not help.

export const environment = {
  production: false,

  // OLD backend — lives on the website's own host.
  apiUrl: 'https://dev2.mahattaart.com/api',
  apiUrlUnauth: 'https://dev2.mahattaart.com/api/api/unauth',
  apiUrlauth: 'https://dev2.mahattaart.com/api/api/auth',

  // NEW backend — the wallpaper module (listing, PDP, quote, cart, services).
  // Cross-origin from dev2, so dev3's FRONTEND_URL must list this site's origin.
  newApiUrl: 'https://dev3.mahattaart.com/adminapi',
  // PayU - Sandbox/Test
  // PayU is gone, and its key and salt with it.
  //
  // The salt is what proved to PayU that an amount had not been tampered with,
  // and it was shipped in this bundle and used in the browser to build the
  // SHA-512 hash — so whoever could change the amount could also sign it. Anyone
  // with DevTools could pay Rs 1 for a Rs 28,296 order and PayU would accept the
  // hash as genuine.
  //
  // Razorpay needs no secret here. Its publishable key arrives at checkout time
  // from the new backend, together with an order id created from our own `order`
  // row, and Razorpay charges what that order says. The browser cannot state an
  // amount at all. Never add a gateway secret back to this file.
  collage_set_flat_discount: '0.15',
  searchApiBase: 'https://api.indiapicture.in/wallsnart-new',
  newSearchApiBase: 'https://api.indiapicture.in/wallsnart-new',
  newwallpaperSearch: 'https://api.indiapicture.in/wallsnart-new/search_wallpaper.php',
  cdn: 'https://storage.googleapis.com/indiapicture',
  // An OLD-backend route, so it belongs on the website's own host — it had been
  // moved to dev3, which runs the new backend and has no such route.
  //
  // NOTE: nothing in src/ reads this key, and `merge-mockup` is not registered in
  // either backend. See the fuller note in environment.dev3.ts.
  mockupUrl: 'https://dev2.mahattaart.com/api/unauth/merge-mockup',
  wallpaper_flat_discount: 20,
  geminiApiKey:"AIzaSyCD67dAjEY1GJqu1Ipmqc3tWvcMbW30CqI"
};
